import React from 'react';
import styled from 'styled-components';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import SectionHeader from '../common/SectionHeader';

const InfoSection = styled.section`
  padding: 80px 0;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const ContactCard = styled.div`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 30px;
  border-radius: ${props => props.theme.borders.radius.regular};
  text-align: center;
  box-shadow: ${props => props.theme.shadows.regular};
  transition: ${props => props.theme.transitions.main};
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const ContactIcon = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(52, 152, 219, 0.1);
  color: ${props => props.theme.colors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0 auto 20px;
`;

const ContactTitle = styled.h3`
  font-size: ${props => props.theme.fontSizes.large};
  margin-bottom: 15px;
  color: ${props => props.theme.colors.secondaryColor};
`;

const ContactText = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  margin-bottom: 5px;
  line-height: 1.6;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ContactInfo = () => {
  const contactDetails = [
    {
      icon: <FaEnvelope />,
      title: 'Email Us',
      info: [
        'kalsacademy1@gmail.com',
        'Send us an email anytime!'
      ]
    },
    {
      icon: <FaPhoneAlt />,
      title: 'Call Us',
      info: [
        '+91 9444108728',
        'Mon-Sat: 9:00 AM - 6:00 PM'
      ]
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Visit Us',
      info: [
        'Chennai, Tamil Nadu',
        'India'
      ]
    },
    {
      icon: <FaClock />,
      title: 'Office Hours',
      info: [
        'Monday - Saturday',
        '9:00 AM - 6:00 PM'
      ]
    }
  ];

  return (
    <InfoSection>
      <div className="container">
        <SectionHeader 
          title="Get in Touch" 
          subtitle="We're here to answer your questions and help you enroll in our programs" 
        />
        
        <ContactGrid>
          {contactDetails.map((detail, index) => (
            <ContactCard key={index}>
              <ContactIcon>{detail.icon}</ContactIcon>
              <ContactTitle>{detail.title}</ContactTitle>
              {detail.info.map((text, i) => (
                <ContactText key={i}>{text}</ContactText>
              ))}
            </ContactCard>
          ))}
        </ContactGrid>
      </div>
    </InfoSection>
  );
};

export default ContactInfo;
